






import { defineComponent } from '@vue/composition-api';
import TeaserText from '@/components/storyblok/TeaserText.vue';
import ImageCaption from '@/components/storyblok/ImageCaption.vue';
import ContentContainer from '@/components/storyblok/ContentContainer.vue';
import EduTitle from '@/components/storyblok/EduTitle.vue';
import RichText from '@/components/storyblok/RichText.vue';

export default defineComponent({
  name: 'AboutPage',
  props: { blok: { type: Object } },
  components: { TeaserText, ImageCaption, ContentContainer, EduTitle, RichText },
});
